import JobListPage from './list'
export default JobListPage
